(function () {
  'use strict';

  var scheduled = false;

  function ensureThemeToggle() {
    var toggle = document.querySelector('.mobile-nav__theme-toggle, .theme-mode-toggle--mobile');
    if (!toggle) return;

    toggle.classList.add('theme-mode-toggle', 'theme-mode-toggle--mobile');
    if (toggle.querySelector('.theme-mode-toggle__switch')) return;

    toggle.innerHTML =
      '<span class="theme-mode-toggle__label theme-mode-toggle__label--light">LIGHT</span>' +
      '<span class="theme-mode-toggle__switch" aria-hidden="true"><span class="theme-mode-toggle__knob"></span></span>' +
      '<span class="theme-mode-toggle__label theme-mode-toggle__label--dark">DARK</span>';
    toggle.setAttribute('aria-label', 'Toggle colour mode');
  }

  function ensureCaseStudies() {
    var item = document.querySelector('.mobile-nav__item--case-studies');
    if (!item) return;

    var button = item.querySelector('.mobile-nav__case-studies-toggle, .mobile-nav__toggle-children');
    var children = item.querySelector('.mobile-nav__children');
    if (!button || !children) return;

    button.textContent = 'CASE STUDIES';
    button.setAttribute('type', 'button');

    if (button.dataset.aelizaCaseStudiesV5 !== 'true') {
      button.setAttribute('aria-expanded', 'false');
      children.setAttribute('aria-hidden', 'true');
      children.hidden = true;
      button.dataset.aelizaCaseStudiesV5 = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
        children.setAttribute('aria-hidden', opening ? 'false' : 'true');
        children.hidden = !opening;
      }, true);
    }
  }

  function run() {
    scheduled = false;
    ensureCaseStudies();
    ensureThemeToggle();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.setTimeout(run, 100);
  window.setTimeout(run, 500);
  window.setTimeout(run, 1200);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());
